module.exports = __webpack_public_path__ + "img/airfocus-K_VeavYEfdA-unsplash.642c22c1.png";